import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=d2ffb312&scoped=true"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"
import style0 from "./Definition.vue?vue&type=style&index=0&id=d2ffb312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ffb312",
  null
  
)

export default component.exports